module.exports = __webpack_public_path__ + "img/bottomBack.8bd1faa8.png";